import koko from './koko-framework/koko'
import { Howler } from 'howler'
import { PreloaderView } from './view/preloader'
import app from './koko-framework/app'
import { v, a } from './koko-framework/shorthand'
import { CaesarCipherView } from './view/CaesarCipherView'
import { HudView } from './view/HudView'
import { PigPenView } from './view/PigPenView'
import { FrequencyAnalysisView } from './view/FrequencyAnalysisView'
import { WrongAnswerPop } from './view/WrongAnswerPop'
import { GameOverView } from './view/GameOverView'
import { QuitPop } from './view/QuitPop'
import { MainMenuView } from './view/MainMenuView'
import { LevelSelectView } from './view/LevelSelectView'
import { ThanksForPlayingView } from './view/ThanksForPlayingView'
import { SharePop } from './view/SharePop'
import { PPHintView } from './view/PPHintView'
import { CSHintView } from './view/CSHintView'
import { FrHintView } from './view/FrHintView'
import { CSTutorialView } from './view/CSTutorialView'
import { PPTutorialView } from './view/PPTutorial'
import { FRTutorialView } from './view/FRTutorialView'
import { CSIntroView } from './view/CSIntroView'
import { PPIntroView } from './view/PPIntroView'
import { FRIntroView } from './view/FRIntroView'
import { ClearPop } from './view/ClearPop'

const main = {
    soundsToLoad: 0,

    init: function () {
        this.setupViews();
        this.setupComplete();
    },

    setupViews: function () {
        koko.views.add('preloader', new PreloaderView(), app.stage);
        // koko.views.add('mainmenu', new MenuView(), app.stage);
        // koko.views.add('ingame', new InGameView(), app.stage);
        // koko.views.add('pausescreen', new PauseScreenView(), app.stage);
        // console.log('setting up views: ', koko);
        koko.views.add('caesarcipherview', new CaesarCipherView(), app.stage);
        koko.views.add('pigpenview', new PigPenView(), app.stage);
        koko.views.add('frequencyanalysisview', new FrequencyAnalysisView(), app.stage);
        koko.views.add('ingamehud', new HudView(), app.stage);
        koko.views.add('wronganswer', new WrongAnswerPop(), app.stage);
        koko.views.add('quitpopup', new QuitPop(), app.stage);
        koko.views.add('gameover', new GameOverView(), app.stage);
        koko.views.add('mainmenu', new MainMenuView(), app.stage);
        koko.views.add('levelselect', new LevelSelectView(), app.stage);
        koko.views.add('thanksforplaying', new ThanksForPlayingView(), app.stage);
        koko.views.add('sharepop', new SharePop(), app.stage);
        koko.views.add('pphint', new PPHintView(), app.stage);
        koko.views.add('cshint', new CSHintView(), app.stage);
        koko.views.add('frhint', new FrHintView(), app.stage);
        koko.views.add('cstutorial', new CSTutorialView(), app.stage);
        koko.views.add('pptutorial', new PPTutorialView(), app.stage);
        koko.views.add('frtutorial', new FRTutorialView(), app.stage);
        koko.views.add('csintro', new CSIntroView(), app.stage);
        koko.views.add('ppintro', new PPIntroView(), app.stage);
        koko.views.add('frintro', new FRIntroView(), app.stage);
        koko.views.add('clearpopup', new ClearPop(), app.stage);
    },

    setupAudio: function () {
        koko.audio.dir = 'audio/'; // local pathname
        //koko.audio.dir = '//s3.amazonaws.com/kokostatic/satsumabowl/audio/';  //AMAZON S3 PATH

        koko.audio.init();
        koko.audio.addSoundGroup('music', 1);
        koko.audio.addSoundGroup('sfx', 1);

        // koko.audio.add(name, url, volume, group, size || 1);
        // AUTOMATICALLY SEARCHES FOR .ogg && .mp3 DEPENDING ON BROWSER CAPABILITY
        /*
        this.addSound('music', 'MUSIC_PLACEHOLDER', 1, 'music', 1);
        //
        this.addSound('sound', 'SOUND_PLACEHOLDER', 1, 'sfx', 1);
        */
        this.addSound('music', 'codebreak_loop', 1, 'music', 1);
        this.addSound('button', 'button', 0.25, 'sfx', 1);
        this.addSound('correct', 'correct_sound', 0.5, 'sfx', 1);
        this.addSound('shiftArrow', 'shiftArrow', 0.8, 'sfx', 1);
        this.addSound('wrong', 'wrong_sound', 1, 'sfx', 1);
        this.addSound('pop1', 'popups/popup_01', 0.5, 'sfx', 1);
        this.addSound('pop2', 'popups/popup_02', 0.5, 'sfx', 1);
        this.addSound('pop3', 'popups/popup_03', 0.5, 'sfx', 1);
        this.addSound('pop4', 'popups/popup_04', 0.5, 'sfx', 1);
        this.addSound('pop5', 'popups/popup_05', 0.5, 'sfx', 1);
        this.addSound('pop6', 'popups/popup_06', 0.5, 'sfx', 1);
        this.addSound('pop7', 'popups/popup_07', 0.5, 'sfx', 1);
        this.addSound('pop8', 'popups/popup_08', 0.5, 'sfx', 1);
        this.addSound('pop9', 'popups/popup_09', 0.5, 'sfx', 1);
        this.addSound('pop10', 'popups/popup_10', 0.5, 'sfx', 1);

        /*
        if (MUTE == 'true' || MUTE == true) {
            koko.audio.setMute(true);
        } else {
            koko.audio.setMute(false);
        }
        */

        Howler.volume(0.7);
    },

    // Use this addSound function if you want the preloader to take in to account audio loading
    addSound: function (name, src, volume, group, size) {
        this.soundsToLoad++;
        koko.audio.add(name, src, volume, group, size);
    },

    setupComplete: function () {
        // check if mobile, if so add style to mobile-push-header
        if (koko.client.system.isMobile) {
            // not needed on android, maybe ios?
            // document.getElementById('mobile-push-header').style.height = '10px';
        }

        // Do we need to try loading user? Load from cookie?
        // debug.log('load user');
        // mainUser.load()
        // v.get()

        // load the preloader graphics, before showing anything
        v.each(['preloader'], 'queueAssets');
        //load manifest
        a.loadManifest(function (p) {
            //LOADING PROGRESS EVENT
        }, function () {

            //queue assets from all other menus
            v.allBut(['preloader'], 'queueAssets');

            //show the preloader
            v.each(['preloader'], 'transitionIn');
        });
        // preloader triggers loading
    },

    //if extra load called, use handler like this
    // userLoaded: function(){
    // 	//load the preloader graphics, before showing anything
    // 	v.each(['preloader'], 'loadAssets');
    // 	v.each(['preloader'], 'queueAssets');
    // 	//load manifest
    // 	a.loadManifest(function(p){
    // 		//LOADING PROGRESS EVENT
    // 	}, function() {
    //
    // 		//queue assets from all other menus
    // 		v.allBut(['preloader'], 'queueAssets');
    //
    // 		//show the preloader
    // 		v.each(['preloader'], 'transitionIn');
    //
    // 		//load them sounds yo
    // 		//au.loadSounds();
    // 	});
    // }
}

export { main as default }

